import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import user from "./stores/user";
import language from "./stores/lang";
import createPersistedState from "vuex-persistedstate";


Vue.use(Vuex, axios,user,language)
/**
 * Base Vuex store module for managing global application state.
 * 
 * Handles:
 * - Application-wide loading status (e.g. for spinners or blocking UI)
 * - Global messages and notifications for the user (e.g. success, error, info)
 * - includes user und language store
 */
export default new Vuex.Store({
  state: {

      loading:false,
      message:{
          text:"",
          type:"",
          display:false
      }
  },
  mutations: {
      setLoadingState(state,payload){
          state.loading=payload;
      },
      setMessage(state,payload){
          state.message.text=payload.text;
          state.message.type=payload.type;
          state.message.display=true;
      },
      resetMessage(state){
          state.message.text="";
          state.message.type="";
          state.message.display=false;
      }
  },

    getters:{
        getLoadingState: state => {
            return state.loading;
        },
        getMessage: state => {
            return state.message;

        }
    },
  actions: {
      showMessage: ({ commit }, payload) => {
          commit('setMessage',payload);
      },
      hideMessage: ({ commit }) => {
          commit('resetMessage');

      }


  },
    modules: {
        user: user,
        lang: language,
    }
    ,
    plugins: [
       createPersistedState({
        paths: ['user', 'lang'],
        reducer: (state) => {
            // 1. Wir erstellen eine tiefe Kopie des aktuellen States
            const storageState = JSON.parse(JSON.stringify(state));

            // 2. Wir löschen die Update-Variablen nur aus der Kopie für den LocalStorage
            if (storageState.user) {
                delete storageState.user.currentBuildHash;
                delete storageState.user.isUpdateAvailable;
            }

            // 3. Nur dieser reduzierte State wird gespeichert
            return {
                user: storageState.user,
                lang: storageState.lang
            };
        }
    })
    ]
})
